import { makeAutoObservable, toJS } from "mobx";
import { apiLink } from "../helpers/constantVariables";
import { apiDelete, apiGet, apiPostPut } from "../api/api_methods";
import {
  getMySubscription,
  redeemPromoCode,
} from "../api/recruiterSubscriptionsApi";
import { getTransactions as fetchTransactions } from "../api/recruiterTransactionsApi";
import {
  getApplicationTracking,
  changeApplicationStatus,
  getApplicationStatus,
} from "../api/recruiterApplicationsApi";
import {
  getRecruiterProfile,
  updateRecruiterProfile,
  deleteRecruiterAccount,
} from "../api/recruiterUsersApi";
import PopupStore from "./popups_store";
class UserStore {
  loading = false;
  dashboardInterviews = [];
  userexperience = [
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ];
  date = "";
  notifications = [];
  transactions = {};
  userDetails = {};
  DeletePopup = false;
  organizations = [];
  showVerificationAlert = false;
  hittedApis = {
    interviewList: false,
    userDetails: false,
    listCoupons: false,
    notifications: false,
  };
  loader = false;

  coupons = [];
  role = null;
  userPic = null;
  userIsAccountVerified = undefined;
  resume = null;
  resumeName = "";
  videoResume = null;
  videoResumeName = "";
  hiredCandidates = [];
  bestPerformers = [];
  bestPerformers2 = [];
  termsAndConditionsPopup = false;
  gender = "";
  showDefault = true;
  clusterHit = false;
  bannerHit = false;
  registerView = false;
  termsAndConditionsView = false;
  resumeReport = null;
  PreviousResumesCount = 0;
  previousSubscriptions = [];
  previousAllSubscriptions = [];
  PreviousResumes = [];
  ResumeSearch = "";
  setPreviousSubscriptions = (details) => {
    this.previousSubscriptions = details;
  };
  setPreviousAllSubscriptions = (details) => {
    this.previousAllSubscriptions = details;
  };
  setResumeSearch = (val) => {
    this.ResumeSearch = val;
  };

  setTermsAndConditionsView = (value) => {
    this.termsAndConditionsView = value;
  };
  setRegisterView = (value) => {
    this.registerView = value;
  };
  setBannerHit = (val) => {
    this.bannerHit = val;
  };
  setClusterHit = (val) => {
    this.clusterHit = val;
  };
  ApplicationDetails = null;
  setApplicationDetails = (details) => {
    this.ApplicationDetails = details;
  };
  setDefault = (val) => {
    this.showDefault = val;
  };
  setGender = (val) => {
    this.gender = val;
  };
  setDate = (date) => {
    this.date = date;
  };
  skills = [];
  setTermsAndConditionsPopup(value) {
    this.termsAndConditionsPopup = value;
  }
  setNotifications(notifications) {
    this.notifications = notifications;
    this.hittedApis.notifications = true;
  }

  async fetchNotifications() {
    if (this.hittedApis.notifications || this.loading) return;

    this.loading = true;
    try {
      const response = await apiGet(`/v1/student/notifications`);
      if (response.status === 200 && response.body.success) {
        this.setNotifications(response.body);
      } else {
        console.error(`Error fetching notifications: ${response.body.message}`);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      this.loading = false;
    }
  }
  setDeletePopup(value) {
    this.DeletePopup = value;
  }
  setBestPerformers(details) {
    this.bestPerformers = details;
  }
  setBestPerformers2(details) {
    this.bestPerformers2 = details;
  }
  setHiredCandidates(details) {
    this.hiredCandidates = details;
  }
  pdf = false;
  setUserExperience(experience) {
    console.log("setUserExperience", experience);
    this.userexperience = experience;
  }
  setpdf(val) {
    this.pdf = val;
  }
  setResumeName(val) {
    this.resumeName = val;
  }
  setVideoResumeName(val) {
    this.videoResumeName = val;
  }
  setResume(pic) {
    this.resume = pic;
  }
  setVideoResume(link) {
    this.videoResume = link;
  }
  setUserPic(pic) {
    this.userPic = pic;
  }
  constructor() {
    makeAutoObservable(this);
  }

  setRole(role) {
    this.role = role;
  }

  setOrganizations(details) {
    this.organizations = details;
  }

  addExtraCoins = (coins) => {
    console.log("addExtraCoins", coins);
    console.log("addExtraCoins", toJS(this.userDetails));

    try {
      this.userDetails.coins =
        parseInt(this.userDetails.coins) + parseInt(coins);
      console.log(toJS(this.userDetails.coins));
    } catch (error) {}
  };

  async DeleteUser(Mail, Password, reason) {
    const body = {
      mail: Mail,
      password: Password,
      reason: reason,
    };
    const response = await deleteRecruiterAccount(body);
    return response?.body?.message;
  }

  async fetchResumeReportById(id) {
    const response = await apiGet(
      `/resumeAnalyser/get-resumeAnalyser-By-Id/${id}`,
    );
    if (response.status === 200) {
      this.resumeReport = response.body.data;
    } else {
      console.log("Failed to fetch resume report");
    }
    return response;
  }

  async fetchResumeReport(body) {
    const id = this.userDetails?._id;
    const response = await apiPostPut(
      body,
      `/resumeAnalyser/create-resume-improvement/${id}`,
      "POST",
    );
    if (response.status === 200) {
      this.resumeReport = response.body.data;
    } else {
      console.log("Failed to fetch resume report");
      alert(response.body.message); //"You does not have enough credits please purchase it."
    }
    return response;
  }
  async postDetailsForMobileVerification(userid, mobileNumber) {
    const body = {
      userId: userid,
      mobile: mobileNumber,
    };
    const response = await apiPostPut(body, `/user/send-otp`, "POST");
    if (response.status === 200) {
      console.log(response?.body?.success);
      return alert(`${response?.body?.Message}`);
    } else {
      return alert(`${response?.body?.Message}`);
    }
  }

  async postOtpForMobileVerification(userid, otp) {
    const body = {
      userId: userid,
      otp: otp,
    };
    const response = await apiPostPut(body, `/user/verify-otp`, "POST");
    if (response.status === 200) {
      console.log(response?.body?.success);
      return alert(`${response?.body?.Message}`);
    } else {
      return alert(`${response?.body?.Message}`);
    }
  }

  async getRankers() {
    const response = await apiGet("/user/best-performers");
    if (response.status === 200) {
      console.log("rankers", response?.body?.data);
      this.setBestPerformers(JSON.stringify(response.body.data));
      this.setBestPerformers2(response.body.data);
      console.log("UserStore.bestPerformers", this.bestPerformers);
    } else {
      return console.log("Failed to fetch rankers");
    }
  }

  async checkSubscription() {
    const response = await getMySubscription();
    if (response.status === 200) {
      console.log("subscription response:", response?.body?.data);
      const data = response?.body?.data;
      let activeSub = null;
      if (Array.isArray(data)) {
        activeSub = data[0] || null;
      } else if (data && typeof data === "object") {
        activeSub = data;
      }
      this.setPreviousSubscriptions(toJS(activeSub));
      console.log("subscriptions1255", toJS(this.previousSubscriptions));
      return activeSub;
    } else {
      console.log("Failed to fetch subscription");
      return null;
    }
  }

  async checkAllSubscription() {
    const response = await getMySubscription();
    if (response.status === 200) {
      console.log("subscription", response?.body?.data);
      const subscription = response?.body?.data;
      this.setPreviousAllSubscriptions(
        toJS(subscription ? [subscription] : []),
      );
      return subscription ? [subscription] : [];
    } else {
      return console.log("Failed to fetch subscription");
    }
  }

  async deleteSubscription(subscriptionId) {
    this.loader = true;
    const response = await apiDelete(
      `/subscriptions/delete-subscription/${subscriptionId}`,
    );
    await new Promise((resolve) => setTimeout(resolve, 2000)); // Add a 2-second delay
    this.loader = false;
    if (response.status === 200) {
      console.log("subscription deleted successfully");
      this.checkAllSubscription();
    } else {
      return alert("Failed to delete subscription");
    }
  }

  async getHiredCandidates() {
    try {
      this.loading = true; // Start loading

      const response = await apiGet("/application/hired-candidates");

      if (response.status === 200) {
        console.log("rankers", response?.body?.data);
        this.setHiredCandidates(JSON.stringify(response.body.data));
        console.log("UserStore.bestPerformers", this.bestPerformers);
      } else {
        console.log("Failed to fetch rankers");
      }
    } catch (error) {
      console.error("Error fetching hired candidates", error);
    } finally {
      this.loading = false; // Stop loading
    }
  }

  async GetApplicationProgress(InterviewId, ApplicationId, mcqId) {
    const response = await getApplicationStatus({
      interviewId: InterviewId || undefined,
      applicationId: ApplicationId || undefined,
      mockTestId: mcqId || undefined,
    });
    if (response.status === 200) {
      this.setApplicationDetails(response.body.data);
    } else {
      this.setApplicationDetails(null);
      console.log("Failed to fetch application progress");
    }
  }

  async getTransactions({ skip = 0, limit = 10, transactionId = null } = {}) {
    this.loader = true;
    const params = { skip, limit };
    if (transactionId) params.transactionId = transactionId;
    const response = await fetchTransactions(params);
    if (response.status === 200) {
      this.transactions = response.body;
    }
    this.loader = false;
  }

  async getUserDetails(refresh = false) {
    if (this.userDetails?.name && !refresh) return;

    let userId = this.userDetails?._id;
    if (!userId) {
      try {
        const localUser = JSON.parse(localStorage.getItem("user"));
        userId = localUser?._id;
      } catch (error) {
        console.error("Error parsing user from localStorage", error);
      }
    }

    const payload = userId ? { id: userId } : {};
    const response = await getRecruiterProfile(payload);

    if (response.status === 200) {
      console.log("user-details fetched:", response?.body?.data);
      return this.setUserDetails(response?.body?.data);
    } else {
      console.log("something went wrong while fetching user details");
    }
  }

  async updateUserDetailsToServer(updateBody) {
    // update the body to server through put api and then update the user details here
    const response = await updateRecruiterProfile(
      this.userDetails?._id,
      updateBody,
    );
    if (response.status === 200) {
      console.log(response?.body?.data);
      return this.setUserDetails(response?.body?.data);
    } else {
      return alert("something went wrong");
    }
  }

  async UpdateUserStatus(body) {
    const response = await updateRecruiterProfile(this.userDetails?._id, body);
    if (response.status === 200) {
      this.setUserDetails(response?.body?.data);
      return true;
    } else {
      alert("something went wrong");
      return false;
    }
  }

  getAllPreviousResumes = async (skip = 0) => {
    this.loader = true;
    try {
      const response = await apiGet(
        `/resumeAnalyser/get-all-resumeAnalyser/${this.userDetails?._id}?skip=${skip}&searchFilter=${this.ResumeSearch}`,
      );
      this.loader = false;
      if (response.status === 200) {
        console.log("previous resumes", response?.body?.data);
        this.PreviousResumes = response?.body?.data;
        this.PreviousResumesCount = response?.body?.count;
      } else {
        return alert("Failed to fetch previous resumes");
      }
    } catch (error) {
      this.loader = false;
    }
  };

  deleteResume = async (resumeId) => {
    const response = await apiDelete(
      `/resumeAnalyser/delete-resumeAnalyser/${resumeId}`,
    );
    if (response.status === 200) {
      console.log("resume deleted successfully");
      this.getAllPreviousResumes();
    } else {
      return alert("Failed to delete resume");
    }
  };

  async UpdateUserDetails(
    name,
    college,
    department,
    year,
    designation,
    skills,

    linkedIn,
    gitHub,
    gender,

    roleId,
  ) {
    const body = {
      name: name,
      college: college,
      branch: department,
      year: year,
      designation: designation,
      skills: skills,
      resume: this.resume,
      resumeName: this.resumeName,
      videoResume: this.videoResume,
      videoResumeName: this.videoResumeName,
      linkedIn: linkedIn,
      gitHub: gitHub,
      gender: gender,

      role: roleId,
    };
    const response = await updateRecruiterProfile(this.userDetails?._id, body);
    if (response.status === 200) {
      console.log(response?.body?.data);
      return this.setUserDetails(response?.body?.data);
    } else {
      return alert("something went wrong");
    }
  }
  setUserDetails(UserDetails) {
    this.showVerificationAlert = !UserDetails?.isAccountVerified;
    this.userDetails = UserDetails;
    this.userPic = UserDetails?.pic ?? null;
    this.userIsAccountVerified = UserDetails?.isAccountVerified;

    // Keep localStorage in sync with the latest user details from server
    if (UserDetails && typeof UserDetails === "object") {
      try {
        const localUser = JSON.parse(localStorage.getItem("user") || "{}");
        const updatedUser = { ...localUser, ...UserDetails };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        console.log("User details synced to localStorage");
      } catch (error) {
        console.error("Error syncing user details to localStorage", error);
      }
    }
  }

  setVerificationAlert(val) {
    this.showVerificationAlert = val ?? false;
  }

  async postRedeemCoupon(couponCode) {
    const response = await redeemPromoCode(couponCode);
    if (response.status === 200) {
      console.log(response?.body?.data);
      this.addExtraCoins(
        response?.body?.data?.data?.credits ??
          response?.body?.data?.data?.discount,
      );
      this.getUserDetails(true);
      alert(response?.body?.data?.message);
      this.getTransactions({});
      return true;
    } else {
      alert(response?.body?.data?.message ?? response?.body?.message);
      return false;
    }
  }

  async hitAllApis(refresh = false) {
    this.fetchDashboardInterviews(refresh);
    this.fetchCoupons(refresh);
  }

  async fetchDashboardInterviews(refresh = false) {
    console.log(this.hittedApis.interviewList);
    if (!refresh && this.hittedApis.interviewList) return;
    console.log("fetchDashboardInterviews 🎉🎉🎉🎉");
    const user = this.userDetails;
    if (!user?._id) return; // if user is not there then return
    try {
      const response = await apiGet(`/interview/user-interviews/${user._id}`);
      if (response.status === 200) {
        console.log("dashboard", response.body?.data);
        this.hittedApis.interviewList = true;
        return this.setDashboardInterviews(response.body?.data);
      } else {
        console.log("Failed to fetch dashboard interviews");
      }
    } catch (error) {
      console.error("Error:", error); // Log the error for debugging
      return console.log("Failed to fetch dashboard interviews");
    }
  }

  setDashboardInterviews(interviews) {
    this.dashboardInterviews = interviews;
  }

  async fetchCoupons(refresh = false) {
    if (!refresh && this.hittedApis.listCoupons) return;
    const response = await apiGet("/coupon/list-coupons");
    if (response.status === 200) {
      this.hittedApis.listCoupons = true;
      console.log("coupons", response?.body?.data);
      return this.setCoupons(response?.body?.data);
    } else {
      return alert("Failed to fetch coupons");
    }
  }

  setCoupons(coupons) {
    this.coupons = coupons;
  }

  async autoGenerateBio(
    name,
    college,
    designation,
    qualification,
    year,
    skills,
  ) {
    const body = {
      prompt: `Generate a bio for me. My name is ${name}. I am currently working as a ${designation}. I completed my ${qualification} in ${year} at ${college} . I have skills in ${skills}.`,
      // prompt: `Generate a professional bio for me . My name is ${name}. I completed a ${qualification} in ${year} from ${college}. I am currently working as a ${designation}. I have a diverse skill set including ${skills}.`,
      model: 1,
      max_tokens: 300,
      stop: null,
    };
    const response = await apiPostPut(body, "/mock/ai-chat", "POST");
    if (response.status === 200) {
      const updateBody = {
        ...this.userDetails,
        bio: response?.body?.data?.body?.content,
      };
      console.log("bio", response?.body?.data?.body?.content);
      return this.setUserDetails(updateBody);
    } else {
      return alert("Failed to generate");
    }
  }
}
export default UserStore;
